import axios from "axios";

export const fetchUpdateUser = async (data: any) => {
    return await axios.post(`/api/user/${data.id}`, data);
}